<template>
  <v-col align-self="center">
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn text rounded v-on="on" @click="roll">
          {{ statCurrentValue }}
          <v-icon :color="iconColorString.color">
            {{ iconColorString.icon }}
          </v-icon>
        </v-btn>
      </template>
      <span>Roll +{{ statName }} ({{ statCurrentValue }})</span>
    </v-tooltip>
  </v-col>
</template>

<script>
  export default {
    props: ['stat'],
    name: 'FooterStat',
    computed: {
      statCurrentValue() {
        return this.$store.state.character.stats[this.stat];
      },
      statName() {
        return `${this.stat.charAt(0).toUpperCase()}${this.stat.slice(1)}`;
      },
      iconColorString() {
        switch (this.stat) {
          case 'edge':
            return {
              icon: 'mdi-run-fast',
              color: 'blue',
            };
          case 'heart':
            return {
              icon: 'mdi-heart',
              color: 'red',
            };
          case 'iron':
            return {
              icon: 'mdi-dumbbell',
              color: 'grey darken-2',
            };
          case 'shadow':
            return {
              icon: 'mdi-ninja',
              color: 'black',
            };
          case 'wits':
            return {
              icon: 'mdi-brain',
              color: 'pink lighten-2',
            };
          default:
            return {
              icon: 'mdi-home',
              color: 'blue',
            };
        }
      },
    },
    methods: {
      roll() {
        this.$store.dispatch('character/rollStat', {
          stat: this.stat,
        });
      },
    },
  };
</script>
